"use client";

import { ResponsiveContainer, PieChart, Pie, Cell } from "recharts";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { StatisticPercentages } from "modules/invoice/types/invoice.interface";

const SEGMENTS = [
  { key: "paid", label: "Encaissé", color: "#10b981" },
  { key: "onHold", label: "En attente", color: "#6b7280" },
  { key: "late", label: "En retard", color: "#ef4444" },
] as const;

export const RevenueDistributionChart = ({
  data,
}: {
  data: StatisticPercentages;
}) => {
  const chartData = SEGMENTS.map((s) => ({
    name: s.label,
    value: data[s.key],
    color: s.color,
  })).filter((d) => d.value > 0);

  const total = chartData.reduce((acc, d) => acc + d.value, 0);

  return (
    <Card className="col-span-full lg:col-span-1">
      <CardHeader className="pb-2">
        <CardTitle className="text-base font-semibold text-gray-900">
          Répartition
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex h-[200px] items-center justify-center">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={chartData}
                cx="50%"
                cy="50%"
                innerRadius="55%"
                outerRadius="85%"
                paddingAngle={3}
                dataKey="value"
                strokeWidth={0}
                animationDuration={600}
              >
                {chartData.map((entry, index) => (
                  <Cell key={index} fill={entry.color} />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
        </div>

        {/* Legend */}
        <div className="mt-4 space-y-3">
          {SEGMENTS.map((s) => {
            const value = data[s.key];
            const pct = total > 0 ? Math.round((value / total) * 100) : 0;
            return (
              <div key={s.key} className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <span
                    className="h-3 w-3 rounded-full"
                    style={{ backgroundColor: s.color }}
                  />
                  <span className="text-sm text-gray-600">{s.label}</span>
                </div>
                <div className="flex items-center gap-3">
                  <div className="h-1.5 w-20 overflow-hidden rounded-full bg-gray-100">
                    <div
                      className="h-full rounded-full transition-all"
                      style={{ width: `${pct}%`, backgroundColor: s.color }}
                    />
                  </div>
                  <span className="w-10 text-right text-sm font-semibold text-gray-900">
                    {pct}%
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};
